import actions from '../actions';
import {connect} from 'react-redux';
import {getCountState} from '../selectors';
import React, {Component} from 'react';

export class CollaboratorCountState extends Component {
    static defaultProps = {
        boardId: null,
        count: 0,
        error: false,
        fetch: () => {},
        loading: true,
        text: ''
    }

    componentDidMount() {
        const {boardId, fetch} = this.props;
        fetch(boardId);
    }

    shouldComponentUpdate(nextProps) {
        const {loading} = nextProps;
        const {props} = this;
        return loading !== props.loading;
    }

    render() {
        const {children} = this.props;
        return children({...this.props});
    }
}

export function mapStateToProps(state) {
    const {count, loading, text} = getCountState(state);
    return {
        count,
        loading,
        text
    };
}

export const mapDispatchToProps = {
    fetch: actions.fetchCount
};

export const CollaboratorCountProvider = connect(mapStateToProps, mapDispatchToProps)(CollaboratorCountState);

export function CollaboratorCount({error, count, loading, text}) {
    if (error || loading) {
        return null;
    }

    return (
        <span className="padding-right-2x collaborator-count">
            {(count > 1) &&
                text
            }
        </span>
    );
}

export default function({boardId}) {
    return (
        <CollaboratorCountProvider boardId={boardId}>
            {(props) => {
                return <CollaboratorCount {...props}/>;
            }}
        </CollaboratorCountProvider>
    );
}


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/collaborator-count.js